export default "__VITE_ASSET__4cdba95f__"